export const colorPalette = {
  gray: '#8e8d8d',
  mediumGray: '#e0e0e0',
  lightGray: 'rgba(0,0,0,0.02)',
  lightOverlay: 'rgba(0,0,0,0.2)',
  lightGreen: '#d9eadd',
  lightBlue: 'rgb(231, 238, 244)',
  pink: '#ffdcdc',
  dark: {
    yellow: '#efc700',
    red: '#ff4c4c',
    green: '#97e47f',
    grey: '#f7f7f7',
    blue: '#3999fd',
  },
  light: {
    yellow: '#efc700',
    red: '#cc1111',
    green: '#66af4e',
    grey: '#f7f7f7',
    blue: '#27509b',
  },
};
